
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const teamSlice = createSlice({
    name: 'teams',
    loading: false,
    initialState: {
        teamlist: [],
        teamCount: 0
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.teamlist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.teamlist = action.payload.data?action.payload.data:[];
            state.teamCount = action.payload.count || 0
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = teamSlice.actions;
//console.log(body);
export const fetchTeams = (body)=> apiCallBegan({
    url: '/team/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














